<template>
    <div class="users">
        <div v-if="visible==true">
            <b-card >
                <b-row>
                    <b-col>
                        <h4>Quote requested by  {{getUser(selectedquote.userid).username}} </h4>
                    </b-col>
                    <b-col>
                        <b-button class="float-right" size="sm" variant="primary" @click="visible=false">Back</b-button>
                    </b-col>
                </b-row>
            </b-card>
            <div>
                <b-card title="Quote Details">
                    <b-row class="mt-2">
                        <b-col md="3">
                            <label for="username"><strong>Created</strong>: {{selectedquote.created}} </label>
                        </b-col>
                        <b-col md="4">

                            <label for="email"><strong>Delivery Location + Address </strong>: {{selectedquote.loadingport}}</label>

                        </b-col>
                        <b-col md="2">
                            <label for="email"><strong>Total Quantity</strong>: {{selectedquote.total}}</label>

                        </b-col>
                        <b-col>
                            <label for="email"><strong>Delivery needed by</strong>: {{selectedquote.eta}}</label>

                        </b-col>
                    </b-row>
                    
                </b-card>

               <b-card title="Quoted Items">
                    <b-table  striped hover :fields="itemfields" :items="noncustomItems">
                        
                        <template v-slot:cell(saleprice)="data">
                            {{getPrice(data.item.inventoryitemid).saleprice}}€
                        </template>
                         <template v-slot:cell(discountprice)="data">
                            {{getPrice(data.item.inventoryitemid).discountprice}}€
                        </template>
                        <template v-slot:cell(discount_subtotal)="data">
                            {{parseInt(data.item.quantity)*parseInt(getPrice(data.item.inventoryitemid).discountprice)}}€
                        </template> 
                        <template v-slot:cell(regular_subtotal)="data">
                            {{parseInt(data.item.quantity)*parseInt(getPrice(data.item.inventoryitemid).saleprice)}}€
                        </template> 
                    </b-table>
                    <div class="container-fluid">
                        <h5 class="mr-5 float-right">Discount total : {{itemfieldsdiscounttotal}}€ </h5>
                        <h5 class=" mr-5 float-right">Regular  total : {{itemfieldstotal}}€ </h5>
                    </div>

                </b-card>
                
               <b-card title="Custom Items">
                    <b-table  striped hover :fields="customitemfields" :items="customItems">
                        
                    </b-table>

                </b-card>

            </div>
            <!-- {{selectedquote}} -->
            <!-- getPrice -->
        </div>
        <div v-else class="row mt-4">
            <div class="col-md-12">
                    <b-table :fields="fields" striped hover :items="quotes">
                        <template v-slot:head(showid)="">
                            #ID
                        </template>
                        <template v-slot:head(loadingport)="">
                            Delivery Address
                        </template>
                        <template v-slot:cell(requestor)="data">
                            {{getUser(data.item.userid).username}}

                        </template>
                        <template v-slot:cell(actions)="data">
                            <b-button variant="primary" size="sm" @click="showQuote(data.item)">View</b-button>
                        </template> 
                    </b-table>

            </div>
        </div>


       
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: "Users",
    computed:{
        ...mapGetters(['quotes','customers','quoteitems','inventoryitems']),

        customItems(){
           return this.quoteitems.filter(item=>item.quoteid==this.selectedquote.id && item.iscustomrequest==true)
        },
        noncustomItems(){
           return this.quoteitems.filter(item=>item.quoteid==this.selectedquote.id && item.iscustomrequest==false)
        },
        itemfieldstotal(){
            let i=0
            this.noncustomItems.forEach(item=>{
                let j,k
                j=parseInt(this.getPrice(item.inventoryitemid).saleprice)
                k=j*item.quantity
                i=i+k

            })
            return i
        },
        itemfieldsdiscounttotal(){
            let i=0
            this.noncustomItems.forEach(item=>{
                let j,k
                j=parseInt(this.getPrice(item.inventoryitemid).discountprice)
                k=j*item.quantity
                i=i+k
            })
            return i
        }
    },
    data() {
      return {
         
          customitemfields:[
              'quantity',
              'description',

          ],
          itemfields:[
            'sku_vcode',
            'saleprice',
            'discountprice',
            'quantity',
            'regular_subtotal',
            'discount_subtotal',
          ],
          fields:[
              'showid',
              'loadingport',
              'total',
              'requestor',
              'actions'

          ],
        selectedquote:'',
        visible: false,

       
      };
    },

    methods: {
        
        getUser(id){
           if(this.customers.length>0){ 
           return this.customers.find(item=>item.id==id)
           }
           else{
               return {username:'NA'}
           }

        },
        getPrice(id){
           return  this.inventoryitems.find(item=>item.id==id)
           
        },
      showQuote(item) {
        this.selectedquote=item
        this.visible = true;
      },
      handlecancel(e) {
        this.visible = false;
      },
    
    }
}
</script>
